import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { Option } from '../types';

interface ResultsChartProps {
  data: Option[];
}

// Maroon-themed palette for results
const COLORS = ['#800000', '#9b1c1c', '#660000', '#4d0000', '#330000'];

const ResultsChart: React.FC<ResultsChartProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 5, right: 30, left: 100, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#f1f5f9" />
        <XAxis type="number" hide />
        <YAxis 
          dataKey="label" 
          type="category" 
          axisLine={false}
          tickLine={false}
          tick={{ fill: '#475569', fontSize: 14, fontWeight: 600 }}
          width={150}
        />
        <Tooltip 
          cursor={{ fill: 'transparent' }}
          contentStyle={{ 
            borderRadius: '12px', 
            border: 'none', 
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
            padding: '12px'
          }}
        />
        <Bar 
          dataKey="votes" 
          radius={[0, 8, 8, 0]} 
          barSize={40}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ResultsChart;